export default "__VITE_ASSET__BRaFLgkh__"